import 'css-chunksrc/client/scenes/optimizedGantt/wbsHeader/styles.scss';export default {
  "wbsHeader": "_wbsHeader_xyy9f_1",
  "detailsViewToggle": "_detailsViewToggle_xyy9f_14",
  "action": "_action_xyy9f_26",
  "controls": "_controls_xyy9f_39",
  "text": "_text_xyy9f_44",
  "icon": "_icon_xyy9f_51",
  "details": "_details_xyy9f_14",
  "detail": "_detail_xyy9f_14",
  "open": "_open_xyy9f_88",
  "header": "_header_xyy9f_95",
  "row": "_row_xyy9f_104",
  "label": "_label_xyy9f_114"
};